export const storageKeys = {
  themeMode: '@slotlooks/theme-mode',
  welcomeSeen: '@slotlooks/welcome-seen',
  session: '@slotlooks/session-record',
  attendance: '@slotlooks/attendance-sessions',
  visitors: '@slotlooks/visitor-entries',
  deviceId: '@slotlooks/device-id',
} as const;

const hasWindow = typeof window !== 'undefined';

export function readStorage(key: string) {
  if (!hasWindow) {
    return null;
  }

  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStorage(key: string, value: string) {
  if (!hasWindow) {
    return;
  }

  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Ignore persistence failures; in-memory state still works.
  }
}

export function removeStorage(key: string) {
  if (!hasWindow) {
    return;
  }

  try {
    window.localStorage.removeItem(key);
  } catch {
    // Ignore persistence failures.
  }
}

export function readJsonStorage<T>(key: string): T | null {
  const raw = readStorage(key);

  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function writeJsonStorage(key: string, value: unknown) {
  writeStorage(key, JSON.stringify(value));
}

export function createStableId(prefix: string) {
  if (hasWindow && typeof window.crypto?.randomUUID === 'function') {
    return `${prefix}-${window.crypto.randomUUID()}`;
  }

  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
